import { render, staticRenderFns } from "./EditionTranslations_TextField.vue?vue&type=template&id=60c1af9c"
import script from "./EditionTranslations_TextField.vue?vue&type=script&lang=js"
export * from "./EditionTranslations_TextField.vue?vue&type=script&lang=js"
import style0 from "./EditionTranslations_TextField.vue?vue&type=style&index=0&id=60c1af9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports